var map = {
	"./ANZ.png": "17b5",
	"./AS.png": "1c6e",
	"./CAMC.png": "1ccc",
	"./CE.png": "9a0e",
	"./MENA.png": "54dd",
	"./SSA.png": "b065",
	"./UKC-1867.png": "0105",
	"./UKC-1896.png": "abae",
	"./UKC-1916.png": "df26",
	"./UKC-1932.png": "315f",
	"./UKC-1941.png": "323e",
	"./UKC-1968.png": "c101",
	"./UKC-1989.png": "a7b6",
	"./UKC-2009.png": "df2a",
	"./US.png": "3abc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2012";